import React, { useState, useEffect } from 'react';

import { T } from 'react-translator-component';
import styled from 'styled-components';

import dropdown from '../../assets/dropdown.png';

export type optionsPropsType = {
  value: string | number;
  id: string | number;
  label: string;
};

interface ISelect {
  value: string | number;
  options?: optionsPropsType[];
  action?: any;
  setloading?: any;
  ordered?: boolean;
}

export const Select = ({ value, options = [], action, ordered }: ISelect) => {
  const [selectOption, setselectOption] = useState(options);
  const [currentValue, setCurrentValue] = useState<any>({ label: '' });
  const [active, setactive] = useState(false);

  const activeList = () => {
    setactive(true);
  };
  const closeList = () => {
    active && setactive(false);
  };

  const onListItemClick = (event: React.MouseEvent<HTMLDivElement>) => {
    action(event.currentTarget.dataset.value);
    setCurrentValue({ label: event.currentTarget.dataset.label });
  };

  const normalizeLabel = (string) => {
    return string?.length >= 0
      ? string?.length > 32
        ? string?.slice(0, 32) + '...'
        : string
      : T('Empty list');
  };

  const inputFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
    setCurrentValue({ label: event.target.value });

    const filterResult = options.filter((option) => {
      return new RegExp(`${event.target.value}`, 'gi').test(option.label);
    });

    const result =
      filterResult.length > 0
        ? filterResult
        : [{ value: '', id: 'empty$', label: 'Sem Resultados' }];

    setselectOption(result);
  };

  useEffect(() => {
    let newOptions = [...options];

    if (ordered) {
      newOptions = newOptions.sort((a, b) =>
        String(a?.label).localeCompare(String(b?.label)),
      );

      const emptyValueIndex = newOptions.findIndex(({ value }) => !value);
      if (emptyValueIndex !== -1) {
        const emptyValue = newOptions[emptyValueIndex];
        newOptions.splice(emptyValueIndex, 1);
        newOptions.unshift(emptyValue);
      }
    }
    setselectOption(newOptions);
  }, [options, ordered]);

  useEffect(() => {
    setCurrentValue(
      options && options.find((option) => `${option.value}` === `${value}`),
    );
  }, [options, value]);

  return (
    <Wrapper active={active} onMouseLeave={closeList}>
      <div className='select' onMouseEnter={activeList}>
        <input
          type='text'
          className='current_value'
          maxLength={40}
          value={normalizeLabel(currentValue?.label)}
          onChange={inputFilter}
        />
        <img src={dropdown} alt='dropdown_icon' className='dropdown_icon' />
      </div>
      <div className='list' onMouseLeave={closeList}>
        {options &&
          selectOption.map((option, index) => (
            <div
              key={index}
              className='list_item'
              data-value={option.value}
              data-label={option.label}
              onClick={onListItemClick}
            >
              {option.label}
            </div>
          ))}
      </div>
    </Wrapper>
  );
};

interface StyleProps {
  active: boolean;
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: ${({ active }) => (active ? 'auto' : '40px')};
  position: relative;

  .select {
    background-color: #fff;
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.1);
    width: 170px;
    padding: 10px 9px;
    border-radius: 3px;
    color: rgba(0, 0, 0, 0.7);
    font-size: 11px;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    transition: background-color 300ms ease-in-out;
    margin: 0 0 0 12px;
    cursor: pointer;
    min-height: 38px;

    &:hover {
      box-shadow: 0 0 4px -1px rgba(0, 0, 0, 0.1);
    }
  }
  .current_value {
    margin-right: 0;
    padding: 0 0 0 6px;
    outline: none;
    width: 100%;
  }
  .dropdown_icon {
    width: 10px;
    object-fit: scale-down;
    float: left;
  }

  .select img {
    transition: 400ms ease-in-out;
    transform: ${({ active }: StyleProps) =>
      active ? 'rotate(-180deg)' : 'rotate(0)'};
  }

  .list {
    position: absolute;
    z-index: 20;
    width: 170px;
    max-height: 200px;
    background-color: #fff;
    box-shadow: 0 0 10px 0px rgba(0, 0, 0, 0.1);
    margin: 2px 0 0 12px;
    border-radius: 8px;
    font-size: 75%;
    overflow-y: scroll;
    transition: all 200ms ease-in-out;
    transform: ${({ active }) =>
      !active ? 'translateY(-10px)' : 'translateY(0)'};
    opacity: ${({ active }) => (!active ? '0' : '1')};
    pointer-events: ${({ active }) => (!active ? 'none' : 'all')};
    top: 36px;
  }

  .list_item {
    width: 100%;
    padding: 7px 5% 7px 5%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: left;

    &:hover {
      background-color: rgba(0, 0, 0, 0.08);
    }
  }

  .list_item:first-child {
    border-radius: 8px 8px 0 0;
  }
  .list_item:last-child {
    border-radius: 0 0 8px 8px;
  }
`;
